import { faSignalStream } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Dismissible, Modal, View } from '@zinc/ui';

import { CurrencyLabel } from 'bz-core-controls';

import withDisplayName from 'bz-utilities/hoc/display-name';
import { useAction } from 'bz-utilities/hooks/action';
import useStable, { useStableAction } from 'bz-utilities/hooks/stable';

import { observer } from 'mobx-react';

import { useAreYouSure } from 'modules/controls/are-you-sure';
import React from 'react';
import z from 'z';
import { useTerminalPaymentDialogStore } from '../../stores/terminal-payment-dialog-store';
import TerminalModalContent from './controls/terminal-modal-content';

export interface IProps {}

const TerminalModal = observer(
  withDisplayName((props: IProps) => {
    const terminalPaymentstore = useTerminalPaymentDialogStore();
    const { transactionAmount, dialogOpen } = terminalPaymentstore;

    const ays = useAreYouSure();

    const closeCheck = useStableAction(() => {
      const { onCancel, isProcessing, onCloseCancel } = terminalPaymentstore;
      const { onOpen } = ays;

      if (!isProcessing) {
        onCancel();
        return;
      }

      onOpen({
        title: 'There is a transaction in progress',
        text: 'Are you sure you want to cancel?',
        onYes: onCloseCancel
      });
    }, [ays, terminalPaymentstore]);

    return (
      <Modal active={dialogOpen} size={'500px'} onClose={closeCheck}>
        <TerminalModalAFU />
        <View gap={2}>
          <Dismissible onClose={closeCheck} closeAriaLabel="Close modal">
            <View direction={'row'} gap={2} align={'center'}>
              <FontAwesomeIcon icon={faSignalStream} size="xl" />
              <Modal.Title>Payment Request was sent to Terminal</Modal.Title>
            </View>
            <Modal.Subtitle>
              Waiting on {z.word('Customer')} to make payment of:&nbsp;
              <CurrencyLabel value={transactionAmount} />
            </Modal.Subtitle>
          </Dismissible>
          <TerminalModalContent />
        </View>
      </Modal>
    );
  }, 'TerminalModal')
);

const TerminalModalAFU = React.memo(
  withDisplayName(() => {
    const terminalPaymentstore = useTerminalPaymentDialogStore();

    React.useEffect(() => {
      return () => {
        window.clearTimeout(terminalPaymentstore.failTimeout);
        window.clearInterval(terminalPaymentstore.interval);
      };
    }, [terminalPaymentstore]);

    return null;
  }, 'TerminalModalAFU')
);

export default TerminalModal;
